import axios from '@/services'
import { useAuthStore } from '@/stores/auth'
import { useFormStore } from '@/stores/form'
import client_lookups from '@/assets/json/clientLookups.json'
import router from '@/router'
import apiHelperService from '@/services'
import { useGlobalStore } from '@/stores/global'

async function handleEstablishmentOptions() {
  const authStore = useAuthStore()
  const formStore = useFormStore()

  const {
    application: { establishment },
    governmentEstablishment: { emirateGovernment, fedralGovernment, semiGovernment }
  } = client_lookups

  if (authStore.user.applicationId !== establishment) {
    return
  }

  const nominatedSchema = formStore.schema.steps[0].form[0].schema
  const personCategory = nominatedSchema.find((s) => s.field_name == 'transactionReasonCategoryId')
  personCategory.options.value.push(
    ...[
      {
        id: 632,
        localizedName: 'investorInPublicInvestments'
      },
      {
        id: 633,
        localizedName: 'investorInRealEstate'
      }
    ]
  )

  const establishmentInfo = await axios.get('/api/establishment/info')
  if (!establishmentInfo) return

  const { type: establishmentType } = establishmentInfo
  const isGovernment = [emirateGovernment, fedralGovernment, semiGovernment].includes(
    establishmentType
  )

  if (isGovernment) {
    personCategory.options.value.push(
      ...[
        {
          id: 634,
          localizedName: 'entrepreneur'
        }
      ]
    )
  }
}

const initForm = async () => {
  const formStore = useFormStore()
  const globalStore = useGlobalStore()
  const { serviceTransactionId } = globalStore.startedService
  const { withException = '', administrativeRegionId = '' } = router.currentRoute.value.query
  const {
    module: { residency }
  } = client_lookups
  formStore.extraMap = {
    ...formStore.extraMap,
    serviceTransactionId,
    administrativeRegionId,
    withException: withException == 'true'
  }
  formStore.draft.request = {
    ...formStore.draft.request,
    fileModuleId: residency,
    serviceTransId: serviceTransactionId,
  }
}
const initInfo = async () => {
  const formStore = useFormStore()
  const authStore = useAuthStore()
  const { userName = '', applicationId = '' } = authStore.user
  const {
    application: {
      resident,
      dubaiResident,
      visaHolder,
      familyMemberResidencyHolder,
      residencyCancelled
    }
  } = client_lookups
  if (
    ![
      resident,
      dubaiResident,
      visaHolder,
      familyMemberResidencyHolder,
      residencyCancelled
    ].includes(applicationId)
  ) {
    return
  }
  const res = await apiHelperService.get(`/api/individual/info`)
  if (res) {
    const {
      arabicFullName = '',
      englishFullName = '',
      nationalityId = '',
      genderId = '',
      dateOfBirth = '',
      countryOfBirthId = '',
      passportNumber = '',
      lastEntryExistPassportNumber = '',
      professionId = '',
      unifiedNumber = ''
    } = res
    formStore.draft.request = {
      ...formStore.draft.request,
      individualInfo: res,
      emailAddress: userName,
      arabicName: arabicFullName,
      englishName: englishFullName,
      currentNationalityId: nationalityId,
      genderId,
      dateOfBirth,
      countryOfBirthId,
      passportNumber: passportNumber || lastEntryExistPassportNumber,
      professionId,
      personUnifiedNumber: unifiedNumber,
      certificateAttestedFromMinistry: '2',
      certificateAttestedFromMinistryOrHigherEducation: '2'
    }
  }
}
export default async function () {
  try {
    await handleEstablishmentOptions()
    await initForm()
    await initInfo()
  } catch (error) {
    console.error('use767Preload error: ', error)
  }
}
